module.exports = __webpack_public_path__ + "static/background-9d05830167f6cb4a8986a059e01d7188.png";